<script setup lang="ts">
import { LogOut, Plus, Settings, ShieldCheck, Users } from '@lucide/vue';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { api } from '../api/client';
const router = useRouter();
const isAdmin = ref(true);
onMounted(async () => { try { isAdmin.value = (await api.me()).role === 'admin'; } catch { /* страница сама обработает вход */ } });
async function logout() { await api.logout(); router.push('/login'); }
</script>
<template>
  <div class="app-shell">
    <header class="topbar">
      <button class="brand" @click="router.push('/')"><img class="brand-logo" src="/brand/bgpu-logo.png" alt="БГПУ" width="127" height="34"/><span class="brand-caption">Формы</span></button>
      <nav class="top-actions">
        <button class="btn btn-quiet journal-nav" @click="router.push('/consent-journal')"><ShieldCheck :size="17"/>Журнал согласий</button>
        <button class="btn btn-quiet journal-nav" :title="isAdmin ? 'Пользователи' : 'Мой пароль'" @click="router.push('/users')"><Users :size="17"/>{{ isAdmin ? 'Пользователи' : 'Мой пароль' }}</button>
        <button v-if="isAdmin" class="icon-btn" title="Настройки" aria-label="Настройки" @click="router.push('/settings')"><Settings :size="19"/></button>
        <button class="btn btn-primary desktop-create" @click="router.push('/forms/new')"><Plus :size="17"/>Новая форма</button>
        <button class="icon-btn" title="Выйти" aria-label="Выйти" @click="logout"><LogOut :size="19"/></button>
      </nav>
    </header>
    <main class="page"><slot/></main>
  </div>
</template>
